import {
  withGetFragmentTable,
  withInsertFragmentTable,
  withInsertTextTable,
  withNormalizeTable,
  withSelectionTable,
} from '@udecode/plate';

import { withDeleteTable } from './withDeleteTable';
import { withSetFragmentDataTable } from './withSetFragmentDataTable';
import { withNormalizeMergableTable } from './withNormalizeMergableTable';

export const withTable = (
  editor,
  plugin,
) => {
  let _editor = editor;
  _editor = withNormalizeTable(editor);
  _editor = withDeleteTable(editor);
  _editor = withGetFragmentTable(editor);
  _editor = withInsertFragmentTable(editor, plugin);
  _editor = withInsertTextTable(editor, plugin);
  _editor = withSelectionTable(editor);
  _editor = withSetFragmentDataTable(editor);
  _editor = withNormalizeMergableTable(editor);

  return _editor;
};
